// Toque de chamada contínuo (cadência tipo telefone: 2 toques, pausa), via Web Audio.
const active = new Map<string, { ctx: AudioContext; timer: number }>();

const ringOnce = (ctx: AudioContext) => {
  const now = ctx.currentTime;
  [0, 0.45].forEach((offset) => {
    const start = now + offset;
    const dur = 0.38;
    const gain = ctx.createGain();
    gain.connect(ctx.destination);
    gain.gain.setValueAtTime(0, start);
    gain.gain.linearRampToValueAtTime(0.35, start + 0.02);
    gain.gain.setValueAtTime(0.35, start + dur - 0.05);
    gain.gain.linearRampToValueAtTime(0, start + dur);
    [440, 480].forEach((freq) => {
      const osc = ctx.createOscillator();
      osc.type = 'sine';
      osc.frequency.value = freq;
      // trêmulo leve para soar como campainha
      const lfo = ctx.createOscillator();
      const lfoGain = ctx.createGain();
      lfo.frequency.value = 20;
      lfoGain.gain.value = 6;
      lfo.connect(lfoGain);
      lfoGain.connect(osc.frequency);
      osc.connect(gain);
      osc.start(start);
      lfo.start(start);
      osc.stop(start + dur);
      lfo.stop(start + dur);
    });
  });
};

export const startCallRingtone = (id: string, maxMs = 25000, onTimeout?: () => void) => {
  if (active.has(id)) return;
  try {
    const Ctx = window.AudioContext || (window as any).webkitAudioContext;
    const ctx: AudioContext = new Ctx();
    void ctx.resume?.();
    ringOnce(ctx);
    const startedAt = Date.now();
    const timer = window.setInterval(() => {
      if (Date.now() - startedAt > maxMs) {
        stopCallRingtone(id);
        onTimeout?.();
        return;
      }
      ringOnce(ctx);
    }, 2500);
    active.set(id, { ctx, timer });
  } catch {
    // ignora erros de áudio
  }
};

export const stopCallRingtone = (id: string) => {
  const entry = active.get(id);
  if (!entry) return;
  window.clearInterval(entry.timer);
  void entry.ctx.close().catch(() => {});
  active.delete(id);
};
